import './components/agent-grid.js';

window.addEventListener('keydown', (e) => {
  if (e.code !== 'Space') return;
  const grid = document.querySelector('agent-grid');
  if (grid) grid.paused = !grid.paused;
  e.preventDefault();
});
